module.exports = __webpack_public_path__ + "static/media/residents.9facf29f.jpg";